'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const SelectContext = React.createContext(void 0);
const useSelectContext = () => {
  const context = React.useContext(SelectContext);
  if (context === void 0) {
    throw new Error("useSelectContext must be used within a SelectContext (which is available by using Select)");
  }
  return context;
};

exports.SelectContext = SelectContext;
exports.useSelectContext = useSelectContext;
//# sourceMappingURL=SelectContext.cjs.js.map
